import header from "./house-key-home-insurance-broker-agent.jpg";
import section1 from "./close-up-people-working-office.jpg";
import section2 from "./financial-inspector-making-report.jpg";
import section3 from "./front-view-couple-looking-house.jpg";
import section4 from "./partnership-business-success-home.jpg";
import section5 from "./process-developing-architectural-project.jpg";

export { header, section1, section2, section3, section4, section5 };
